import { useGetShopQueryParams } from "../../../../search/hooks";

export const useExchangeDeparturePageRoute = () => {
  return useGetShopQueryParams();
};
